import { render, staticRenderFns } from "./VeisInstructorIcard.vue?vue&type=template&id=161fc020&"
import script from "./VeisInstructorIcard.vue?vue&type=script&lang=js&"
export * from "./VeisInstructorIcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports